import config from '../../../config';
import {checkStatus, authFetch} from '../../utils/http';

export default class LiveDocumentTypeService {
  getByCountryAndProjectType(country, projectType) {
    return authFetch(`${config.documentTypeApi}/api/v1/documents/types/project?country=${country}&projectType=${projectType}`)
      .then(checkStatus)
      .then(response => response.json());
  }

  getRequiredDocumentTypes(projectId) {
    return authFetch(`${config.documentTypeApi}/api/v1/project-obligations/projects/${projectId}/document-types`)
      .then(checkStatus)
      .then(response => response.json());
  }

  setRequiredDocumentTypes(projectId, requiredDocumentTypes) {
    return authFetch(`${config.documentTypeApi}/api/v1/project-obligations/projects/${projectId}/document-types`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requiredDocumentTypes)
    })
      .then(checkStatus);
  }

  getEquivalences(documentId, organisationId) {
    return authFetch(`${config.documentTypeApi}/api/v1/documents/types?equivalentTo=${documentId}&organisationId=${organisationId}`)
      .then(checkStatus)
      .then(response => response.json());
  }

  getCollectableByMandate(organisationId) {
    return authFetch(`${config.documentTypeApi}/api/v1/documents/types?organisationId=${organisationId}&collectableByMandate=true`)
      .then(checkStatus)
      .then(response => response.json());
  }

  getDocumentAddableForOrganisation(organisationId, country) {
    return authFetch(`${config.documentTypeApi}/api/v1/documents/types/can-be-added?organisationId=${organisationId}&country=${country}`)
      .then(checkStatus)
      .then(response => response.json());
  }

  getBySubtypeCodes(subtypeCodes) {
    return authFetch(`${config.documentApi}/api/v1/documents/types?subtypeCodes=${subtypeCodes.join(',')}`)
      .then(checkStatus)
      .then(response => response.json());
  }

  getMetadataFields(subTypeCode) {
    return authFetch(`${config.documentApi}/api/v1/documents/types/fields?subtype-code=${subTypeCode}`)
      .then(checkStatus)
      .then(response => response.json());
  }
}
